/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ProcessingInputs */

const cs_enum_processing = /** @type {(inputs: Enum_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpracovává se`)
};

const en_enum_processing = /** @type {(inputs: Enum_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing`)
};

/**
* | output |
* | --- |
* | "Processing" |
*
* @param {Enum_ProcessingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_processing = /** @type {((inputs?: Enum_ProcessingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ProcessingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_processing(inputs)
	return cs_enum_processing(inputs)
});